import styles from './authMarketingSideFallback.module.scss';

/** Skeleton matching {@link ClockoutExampleSection} layout. */
export default function ExampleMarketingSkeleton() {
    return (
        <div className={styles.headingSection}>
            <div className={styles.titleBlock}>
                <div className={`${styles.skeletonLine} ${styles.titleLinePrimary}`} />
                <div className={`${styles.skeletonLine} ${styles.titleLineHighlight}`} />
            </div>
            <div className={styles.divider} />
            <div className={styles.descriptionBlock}>
                <div className={`${styles.skeletonLine} ${styles.descriptionLine}`} />
                <div className={`${styles.skeletonLine} ${styles.descriptionLineShort}`} />
            </div>
            <div className={styles.productImageWrap}>
                <div className={styles.productImagePlaceholder} />
            </div>
        </div>
    );
}
